import { AxiosService } from './axios.service'
import { SearchService } from './search.service'
import {
	paginationErrorHandler,
	paginationSuccessHandler
} from './pagination-handlers'

const ORDERS_PATH = 'me/orders'

function ordersSuccessHandler({ data }) {
	if (!data.success) return { rows: [], totalRows: 0 }

	return {
		rows: data.data.items,
		totalRows: data.data.totalCount
	}
}

/**
 * Defines the API methods for client reports
 */
export class ClientReportsService extends SearchService {
	static baseURL = 'cliente/relatorios'

	/**
	 * Searches the client's purchases against the MuviHub orders API.
	 * status/dateStart/dateEnd/sidx/sord mirror the legacy
	 * pesquisar-minhas-compras contract (see my-orders.http). productId has
	 * no equivalent on this endpoint yet, so it isn't forwarded.
	 */
	static searchPurchases({ page, rowsPerPage, sidx, sord, status, dateStart, dateEnd }) {
		return AxiosService.getMuviHub(ORDERS_PATH, {
			params: {
				page,
				pageSize: rowsPerPage,
				sidx,
				sord,
				status: status || undefined,
				dateStart: dateStart || undefined,
				dateEnd: dateEnd || undefined
			}
		})
			.then(ordersSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Gets client's pay history
	 */
	static getPayHistory(params) {
		return AxiosService.get(
			`${ClientReportsService.baseURL}/historico-de-pagamentos`,
			{
				params
			}
		)
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}
}
